import { gql } from "@apollo/client";

export const GET_ALL_TRUCKS_WITH_FULL_DETAIL = gql`
    query allTrucks {
        id

        number
        maxLoadInLbs

        createdBy {
            id
            firstName
            lastName
        }
        lastUpdatedBy {
            id
            firstName
            lastName
        }
    }
`

export const GET_ALL_TRUCKS_FOR_SELECT_FIELD = gql`
    query {
        allTrucks {
            id
            number
            maxLoadInLbs
        }
    }
`

export const GET_TRUCK_BY_ID_WITH_FULL_DETAIL = gql`
    query truck($id: Int!) {
        truck(id: $id) {
            id

            number
            maxLoadInLbs

            createdBy {
                id
                firstName
                lastName
            }
            lastUpdatedBy {
                id
                firstName
                lastName
            }
        }
    }
`